import { Typography } from "@mui/material"

export function TaskReadOnlyRelationshipRow({ item }) {
    return (
        <Typography variant="body2" color="text.secondary">
            {item.type}: {item.target}
            {item.note ? ` (${item.note})` : ""}
        </Typography>
    )
}
